<template>
  <v-card>
    <v-card-title>
      <v-row>
        <v-col>
          <v-text-field
            v-model="search.orderNumber"
            :label="$t('label.purchaseOrder')"
            dense
            outlined
            clearable
          ></v-text-field>
        </v-col>
        <v-col>
          <v-btn
            color="primary"
            @click="getPurchaseOrders()"
            >
            <v-icon>
              mdi-magnify
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-card-title>
    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="orders"
        :loading="isLoading"
        :options.sync="options"
        :server-items-length="totalOfItems"
        :footer-props="footerProps"
      >
        <template v-slot:[`item.statusId`]="{ item }">
          <v-chip
            :color="getStatusColor(item.statusId)"
            >
            {{ getStatusName(item.statusId) }}
          </v-chip>
        </template>
        <template v-slot:[`item.options`]="{ item }">
          <v-btn class="btn-action" icon :title="$t('label.details')" small depressed @click.stop="selectPurchaseOrder(item, 'detail')">
            <v-icon color="primary">mdi-file-document</v-icon>
          </v-btn>
          <v-btn class="btn-action" icon :title="$t('label.messages')" small depressed @click.stop="selectPurchaseOrder(item, 'mail')">
            <v-icon color="primary">mdi-message</v-icon>
          </v-btn>
          <v-btn class="btn-action" icon :title="$t('label.pdf')" small depressed @click.stop="downloadPdf(item)">
            <v-icon color="red">mdi-file-pdf-box</v-icon>
          </v-btn>
          <v-chip small color="success" v-if="!item.readByVendor">{{ $t('label.new') }}</v-chip>
          <v-chip small color="default" v-else>{{ $t('label.read') }}</v-chip>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { loading, showMessage } from '../../../mixins'
import { formatDate, extractDateTime, formatCurrency } from '../../../core/sharedFunctions'
import { saveAs } from 'file-saver'
import { headerState } from '../../../core/PurchaseOrders/states'

export default {
  name: 'PaymentsList',
  mixins: [loading, showMessage],
  data: () => ({
    orders: [],
    purchaseOrderSelected: {},
    // search: '',
    search: {
      orderNumber: ''
    },
    options: {},
    itemsPerPage: 10,
    page: 1,
    totalOfItems: 0,
    footerProps: {
      'items-per-page-options': [5, 10, 15, 20]
    }
    // options: {
    //   sortBy: ['readByVendor', 'issuedOnDate'],
    //   sortDesc: [false, true],
    //   itemsPerPage: 10
    // }
  }),
  computed: {
    headers () {
      const headers = [
        { text: this.$t('label.purchaseOrder'), value: 'purchaseOrderNumber', align: 'center', sortable: true, filterable: true },
        { text: this.$t('label.issueOn'), value: 'issuedOnDate', align: 'center', sortable: true, filterable: true },
        { text: this.$t('label.status'), value: 'statusId', align: 'center', sortable: true, filterable: true },
        { text: this.$t('label.lines'), value: 'totalLines', align: 'center', sortable: true, filterable: false },
        { text: this.$t('label.currency'), value: 'currency', align: 'center', sortable: true, filterable: true },
        { text: this.$t('label.total'), value: 'total', align: 'center', sortable: true, filterable: true },
        { text: this.$t('label.options'), value: 'options', align: 'center', sortable: false, filterable: false }
      ]
      return headers
    }
  },
  methods: {
    getPurchaseOrders () {
      this.changeLoadingStatus(true)

      const params = new URLSearchParams()
      if (this.search.orderNumber) {
        params.append('orderNumber', this.search.orderNumber)
      }

      this.$proxy.get(`api/purchaseorders/${this.page}/${this.itemsPerPage}?${params.toString()}`)
        .then((r) => {
          this.totalOfItems = r.data.totalOfItems
          const orders = r.data.orders
          this.orders = orders.map((p) => {
            p.issuedOnDate = formatDate(new Date(extractDateTime(p.issuedOnDate)))
            p.total = formatCurrency(p.total)
            return p
          })
        })
        .catch((e) => {
          this.showHttpErrorMessage(e)
        })
        .finally(() => {
          this.changeLoadingStatus(false)
        })
    },
    selectPurchaseOrder (item, action) {
      item.readByVendor = true
      this.$emit('itemSelected', item, action)
    },
    downloadPdf (item) {
      this.changeLoadingStatus(true)
      this.$proxy.getDownload(`api/purchaseorders/${item.id}/pdf`)
        .then((r) => {
          saveAs(r.data, `PurchaseOrder-${item.id}.pdf`)
        })
        .catch((e) => {
          console.log(e)
          this.showHttpErrorMessage(e)
        })
        .finally(() => {
          this.changeLoadingStatus(false)
        })
    },
    getStatusName (statusId) {
      switch (statusId) {
        case headerState.OPEN_ORDER:
          return this.$t(`purchaseOrderHeaderState.${headerState.OPEN_ORDER}`)
        case headerState.PARTIAL_ORDER:
          return this.$t(`purchaseOrderHeaderState.${headerState.PARTIAL_ORDER}`)
        case headerState.COMPLETE_ORDER:
          return this.$t(`purchaseOrderHeaderState.${headerState.COMPLETE_ORDER}`)
        default:
          return '-'
      }
    },
    getStatusColor (statusId) {
      switch (statusId) {
        case headerState.OPEN_ORDER:
          return ''
        case headerState.PARTIAL_ORDER:
          return 'yellow'
        case headerState.COMPLETE_ORDER:
          return 'green'
      }
    }
  },
  mounted () {
    // this.getPurchaseOrders()
  },
  watch: {
    options: {
      handler () {
        const { page, itemsPerPage } = this.options
        this.page = page
        this.itemsPerPage = itemsPerPage
        this.getPurchaseOrders()
      },
      deep: true
    }
  }
}
</script>

<style>
 .btn-action {
   margin-right: 5px;
   margin-top: 2px;
   margin-bottom: 2px;
 }
</style>
